/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Search_FilesInputs */

const en_common_search_files = /** @type {(inputs: Common_Search_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search files`)
};

const es_common_search_files = /** @type {(inputs: Common_Search_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar archivos`)
};

/**
* | output |
* | --- |
* | "Search files" |
*
* @param {Common_Search_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_search_files = /** @type {((inputs?: Common_Search_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Search_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_search_files(inputs)
	return en_common_search_files(inputs)
});